export default __webpack_public_path__ + "static/media/vambraces_of_the_wicked.81fcd780.jpg";